/**
 * Show an info flash that does auto-remove
 *
 * @see show
 */
function info(message, options = {}) {
  show(message, { ...options, type: "info" });
}

/**
 * Show a success flash that does auto-remove
 *
 * @see show
 */
function success(message, options = {}) {
  show(message, { ...options, type: "success" });
}

/**
 * Show a warning flash that does auto-remove
 *
 * @see show
 */
function warning(message, options = {}) {
  show(message, { ...options, type: "warning" });
}

/**
 * Show an error flash that does not auto-remove
 *
 * @see show
 */
function error(message, options = {}) {
  show(message, { autoremove: false, ...options, type: "error" });
}

/**
 * Show a flash with the given message
 *
 * @param {string} message
 * @param {Object} options
 * @property {number} options.autoremoveDelay - autoremove duration in ms
 * @property {boolean} options.autoremove - whether to autoremove, defaults to true
 * @property {string} options.type - flash type, defaults to 'info'
 * @property {boolean} options.closeable - whether to show a close button, defaults to true
 * @property {boolean|string} options.icon - whether to show an icon, defaults to true (or a string with the icon name)
 */
function show(message, options = {}) {
  const {
    type = "info",
    autoremoveDelay = 3000,
    autoremove = true,
    closeable = true,
    icon = false,
    target = document.body,
  } = options ?? {};

  const flash = document.createElement("sp-alert");

  flash.setAttribute("type", type);
  flash.setAttribute("text", message);
  flash.setAttribute("closeable", closeable);
  flash.setAttribute("icon", icon);
  flash.setAttribute("flash", true);
  flash.setAttribute("variant", "elevated");

  if (autoremove) {
    setTimeout(() => flash.remove(), autoremoveDelay);
  }

  target.insertBefore(flash, target.firstChild);
}

export function useFlash() {
  return {
    info,
    success,
    warning,
    error,
    show,
  };
}
